document.addEventListener('DOMContentLoaded', () => {

  /*
  =====================================================
  ELEMENTS
  =====================================================
  */

  const tabs = document.querySelectorAll('[data-auth-tab]');

  const panels = document.querySelectorAll('[data-auth-panel]');

  const passwordToggles = document.querySelectorAll('.bahari-password-toggle');

  if (!tabs.length || !panels.length) return;

  /*
  =====================================================
  HELPERS
  =====================================================
  */

  const removeActiveStates = () => {

    tabs.forEach((tab) => {
      tab.classList.remove('is-active');
    });

    panels.forEach((panel) => {
      panel.classList.remove('is-active');
    });

  };

  /*
  =====================================================
  ACTIVATE PANEL
  =====================================================
  */

  const activatePanel = (target) => {

    removeActiveStates();

    /*
    =========================
    ACTIVATE TAB
    =========================
    */

    const activeTab = document.querySelector(
      `[data-auth-tab="${target}"]`
    );

    if (activeTab) {
      activeTab.classList.add('is-active');
    }

    /*
    =========================
    ACTIVATE PANEL
    =========================
    */

    const activePanel = document.querySelector(
      `[data-auth-panel="${target}"]`
    );

    if (activePanel) {

      activePanel.classList.add('is-active');

      /*
      =========================
      ACCESSIBILITY
      =========================
      */

      const firstInput =
        activePanel.querySelector('input');

      if (firstInput) {

        setTimeout(() => {
          firstInput.focus();
        }, 120);

      }

    }

  };

  /*
  =====================================================
  HASH ROUTING
  =====================================================
  */

  const handleHash = () => {

    const hash =
      window.location.hash.replace('#', '');

    /*
    =========================
    VALID ROUTES
    =========================
    */

    const validRoutes = [
      'login',
      'register',
      'recover'
    ];

    /*
    =========================
    DEFAULT ROUTE
    =========================
    */

    const route =
      validRoutes.includes(hash)
        ? hash
        : 'login';

    activatePanel(route);

  };

  /*
  =====================================================
  TAB CLICK
  =====================================================
  */

  tabs.forEach((tab) => {

    tab.addEventListener('click', () => {

      const target =
        tab.dataset.authTab;

      if (!target) return;

      window.location.hash = target;

    });

  });

  /*
  =====================================================
  RECOVER LINKS
  =====================================================
  */

  document.querySelectorAll('a[href="#recover"]').forEach((link) => {

    link.addEventListener('click', () => {
      window.location.hash = 'recover';
    });

  });

  /*
  =====================================================
  BACK TO LOGIN
  =====================================================
  */

  document.querySelectorAll('a[href="#login"]').forEach((link) => {

    link.addEventListener('click', () => {
      window.location.hash = 'login';
    });

  });

  /*
  =====================================================
  PASSWORD TOGGLE
  =====================================================
  */

  passwordToggles.forEach((toggle) => {

    toggle.addEventListener('click', () => {

      const wrapper =
        toggle.closest('.bahari-field__input');

      if (!wrapper) return;

      const input =
        wrapper.querySelector('input');

      if (!input) return;

      const eyeOpen =
        toggle.querySelector('.bahari-eye-open');

      const eyeClose =
        toggle.querySelector('.bahari-eye-close');

      /*
      =========================
      SHOW PASSWORD
      =========================
      */

      if (input.type === 'password') {

        input.type = 'text';

        if (eyeOpen) {
          eyeOpen.style.display = 'none';
        }

        if (eyeClose) {
          eyeClose.style.display = 'block';
        }

        toggle.setAttribute(
          'aria-label',
          'Ocultar contraseña'
        );

      }

      /*
      =========================
      HIDE PASSWORD
      =========================
      */

      else {

        input.type = 'password';

        if (eyeOpen) {
          eyeOpen.style.display = 'block';
        }

        if (eyeClose) {
          eyeClose.style.display = 'none';
        }

        toggle.setAttribute(
          'aria-label',
          'Mostrar contraseña'
        );

      }

    });

  });

  /*
  =====================================================
  KEYBOARD ACCESSIBILITY
  =====================================================
  */

  passwordToggles.forEach((toggle) => {

    toggle.addEventListener('keydown', (event) => {

      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {

        event.preventDefault();

        toggle.click();

      }

    });

  });

  /*
  =====================================================
  SHOPIFY ERRORS
  =====================================================
  */

  const hasRecoverErrors =
    document.querySelector('#RecoverEmail')
      ?.closest('form')
      ?.querySelector('.bahari-auth__message');

  if (hasRecoverErrors) {

    window.location.hash = 'recover';

  }

  /*
  =====================================================
  INITIALIZE
  =====================================================
  */

  handleHash();

  /*
  =====================================================
  HASH CHANGE
  =====================================================
  */

  window.addEventListener(
    'hashchange',
    handleHash
  );

});